import config from "@/utils/config";
import {
    isVaild
} from "@/utils/validate"

export function getCloudUrl(path) {
    if (!isVaild(path)) {
        return ""
    }
    if (path.indexOf('http://') >= 0 || path.indexOf('https://') >= 0) {
        return path
    }
    return config.RESOURCES + path;
}

export function getPreviewImgUrl(entity) {
    var path = ""
    if (entity.fileType === 0) {
        path = entity.fileUrl
    } else {
        path = entity.faceUrl
    }
    return getCloudUrl(path)
}

export function getPreviewVideoUrl(entity) {
    return getCloudUrl(entity.fileUrl)
}

export function getLocalFileURL(uploadFile) {
    var url = null;
    if (window.createObjectURL != undefined) {
        url = window.createObjectURL(uploadFile.raw)
    } else if (window.URL != undefined) {
        url = window.URL.createObjectURL(uploadFile.raw)
    } else if (window.webkitURL != undefined) {
        url = window.webkitURL.createObjectURL(uploadFile.raw)
    }
    return url;
}

export function handleUrlEncode(url, params) {
    for (var key in params) {
        if (isVaild(params[key])) {
            if (key === 'where') {
                url += key + "=" + encodeURIComponent(JSON.stringify(params[key])) + "&"
            } else {
                url += key + "=" + params[key] + "&"
            }
        }
    }
    return url;
}
